// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type UAVariableValue
 * 
 * @export
 */
export type UAVariableValue = number | string;

export function UAVariableValueFromJSON(json: any): UAVariableValue {
    return UAVariableValueFromJSONTyped(json, false);
}

export function UAVariableValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAVariableValue {
    if (json == null) {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {} as any;
}

export function UAVariableValueToJSON(json: any): any {
    return UAVariableValueToJSONTyped(json, false);
}

export function UAVariableValueToJSONTyped(value?: UAVariableValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}

